export const data =[
  {
    "Title": "All Man",
    "Issue #": 1961,
    "Condition": "FN+",
    "Website Notes": "Torture Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Alter Ego",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Alter Ego",
    "Issue #": 8,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Amazing World of DC Comics",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Amazing World of DC Comics",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Amazing World of DC Comics",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Amazing World of DC Comics",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Amazing World of DC Comics",
    "Issue #": 17,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 22,
    "": ""
  },
  {
    "Title": "Blazing Combat",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": ""
  },
  {
    "Title": "Captain Britain (1985)",
    "Issue #": 6,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Captain Britain (1985)",
    "Issue #": 7,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Captain Britain (1985)",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Captain Britain (1985)",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Captain Britain (1985)",
    "Issue #": 12,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Captain Britain (1985)",
    "Issue #": 14,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 2,
    "": ""
  },
  {
    "Title": "Cartoons",
    "Issue #": 17,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Castle of Frankenstein",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "Stan Lee Interview",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Chilling Tales of Horror",
    "Issue #": "V1#3",
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Comics Scene",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": 1981,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Comix Book",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "Kitchen Sink",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Comix International",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "All Corben Issue",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Creepy",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 50,
    "": "Mike"
  },
  {
    "Title": "Creepy",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": "Joe"
  },
  {
    "Title": "Creepy",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Creepy",
    "Issue #": 29,
    "Condition": "VF/NM",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Creepy",
    "Issue #": 146,
    "Condition": "VF/NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Creepy",
    "Issue #": "1969 Annual",
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Creepy",
    "Issue #": "1970 Annual",
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Creepy",
    "Issue #": "1971 Annual",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Deadliest Heroes of Kung Fu",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Bruce Lee C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 8,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 12,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 17,
    "Condition": "VF/NM",
    "Website Notes": "B Lee Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 25,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 28,
    "Condition": "FN+",
    "Website Notes": "Bruce Lee C/S",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 18,
    "": "GA Collectables"
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 29,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Deadly Hands of Kung Fu",
    "Issue #": 30,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 12,
    "": ""
  },
  {
    "Title": "Devilina",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Dracula Lives!",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Dracula Lives!",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Dracula Lives!",
    "Issue #": 3,
    "Condition": "VF+",
    "Website Notes": "1st Solomon Kane",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Dracula Lives!",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "1st Lilith",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Dracula Lives!",
    "Issue #": 11,
    "Condition": "VF/NM",
    "Website Notes": "Lilith",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Dracula Lives!",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Dracula Lives!",
    "Issue #": 13,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Dracula Lives! Annual",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Eerie",
    "Issue #": 7,
    "Condition": "F/VF",
    "Website Notes": "Frazetta",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Eerie",
    "Issue #": 61,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Eerie",
    "Issue #": 66,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Eerie",
    "Issue #": 79,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Eerie",
    "Issue #": 84,
    "Condition": "NM-",
    "Website Notes": "Starlin",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Eerie",
    "Issue #": "1971 Annual",
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Emergency (Charlton)",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Adams c/a",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Emergency (Charlton)",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "Adams c/a",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Epic Illustrated",
    "Issue #": 34,
    "Condition": "VF/NM",
    "Website Notes": "Last Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 150,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 11,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 12,
    "Condition": "CGC 5.5",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 13,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 65,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 16,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 85,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 20,
    "Condition": "F/G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 21,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 40,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 37,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 50,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 52,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 82,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 85,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 90,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 97,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 98,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 99,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 100,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 101,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters",
    "Issue #": 180,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 11,
    "": "Telegraph"
  },
  {
    "Title": "Famous Monsters Annual",
    "Issue #": 1962,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Famous Monsters Annual",
    "Issue #": 1962,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Famous Monsters Annual",
    "Issue #": 1962,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Famous Monsters Convention",
    "Issue #": 1974,
    "Condition": "VF",
    "Website Notes": "Signed by Forry!",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Haunt of Horror",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Heroes Inc",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": 1976,
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Horror Tales",
    "Issue #": "V1#9",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Horror Tales",
    "Issue #": "V7#4",
    "Condition": "VF/NM",
    "Website Notes": "Giant Size",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Horror Tales",
    "Issue #": "V9#3",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Hulk",
    "Issue #": 16,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 8,
    "": "Telegraph"
  },
  {
    "Title": "Hulk",
    "Issue #": 19,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "two avail",
    "Cost Basis": 15,
    "": "Telegraph"
  },
  {
    "Title": "Hulk",
    "Issue #": 21,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Hulk",
    "Issue #": 22,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 11,
    "": "Telegraph"
  },
  {
    "Title": "Hulk",
    "Issue #": 23,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Legion of Monsters",
    "Issue #": 1,
    "Condition": "CGC 9.0",
    "Website Notes": "1st Appearance",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Marvel Comics Super Special",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "KISS",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 1100,
    "": ""
  },
  {
    "Title": "Marvel Comics Super Special",
    "Issue #": 4,
    "Condition": "NM-",
    "Website Notes": "Beatles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Death of Captain Marvel 2nd Print",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Elric",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Dreadstar",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "1st New Mutants",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "X-Men",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": 18,
    "Condition": "NM",
    "Website Notes": "She Hulk",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Marvel Graphic Novel",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Emperor Doom",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Marvel Preview",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": ""
  },
  {
    "Title": "Marvel Preview",
    "Issue #": 4,
    "Condition": "CGC 9.4",
    "Website Notes": "1st Starlord",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": ""
  },
  {
    "Title": "Marvel Preview",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "1st Rocket Raccoon",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 135,
    "": ""
  },
  {
    "Title": "Marvel Preview",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "Thor",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Marvel Preview",
    "Issue #": 12,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Marvel Preview",
    "Issue #": 16,
    "Condition": "NM",
    "Website Notes": "Masters of Terror",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Marvel Super Action",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Marvel Super Action",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Punisher",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Monster Parade",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Monster Parade",
    "Issue #": 3,
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Monsters and Heroes",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "Larry Ivie",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monsters and Things",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Monsters and Things",
    "Issue #": 2,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 80,
    "": ""
  },
  {
    "Title": "Monsters of the Movies",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "King Kong",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Monsters of the Movies",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "Frankenstein",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monsters of the Movies",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "Vampires",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monsters of the Movies",
    "Issue #": 4,
    "Condition": "F/VF",
    "Website Notes": "Werewolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monsters Unleashed",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "Boris",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Monsters Unleashed",
    "Issue #": 4,
    "Condition": "VF",
    "Website Notes": "Werewolf",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monsters Unleashed",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monsters Unleashed Annual",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Monster Times",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "King Kong",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Monster Times",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "Star Trek",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monster Times",
    "Issue #": 10,
    "Condition": "F/VF",
    "Website Notes": "EC Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Monster World",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Nam",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Nightmare",
    "Issue #": 9,
    "Condition": "VF+",
    "Website Notes": "Wrightson",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Nightmare Annual",
    "Issue #": 1972,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Nightmare Annual",
    "Issue #": 1973,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Planet of the Apes",
    "Issue #": "1-29",
    "Condition": "VF/NM",
    "Website Notes": "Complete Set",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 265,
    "": "Telegraph"
  },
  {
    "Title": "Planet of the Apes",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Planet of the Apes",
    "Issue #": 2,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Planet of the Apes",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Psycho",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Psycho",
    "Issue #": 6,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Rampaging Hulk",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Rampaging Hulk",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Rampaging Hulk",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Rampaging Hulk",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Rampaging Hulk",
    "Issue #": 9,
    "Condition": "VF/NM",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Raphael",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Roger Fairfax"
  },
  {
    "Title": "Savage Tales",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "1st Man Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Aftertime"
  },
  {
    "Title": "Savage Tales",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "1st Man Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "1st Man Thing",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Aftertime"
  },
  {
    "Title": "Savage Tales",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 6,
    "Condition": "NM",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 7,
    "Condition": "NM",
    "Website Notes": "Adams",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 8,
    "Condition": "VF/NM",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 10,
    "Condition": "VF/NM",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Savage Tales",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "Ka-Zar",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Shock",
    "Issue #": "V1#2",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Six Million Dollar Man",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Six Million Dollar Man",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  },
  {
    "Title": "Spacemen",
    "Issue #": 4,
    "Condition": "VG-",
    "Website Notes": "Flash Gordon",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Spectacular Spider-Man",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Starlog",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Star Trek",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Star Warp",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Tales From the Tomb",
    "Issue #": "V4#4",
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Tales of the Killers",
    "Issue #": 11,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Tales of the Zombie",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Boris",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Tales of the Zombie",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Tales of the Zombie",
    "Issue #": "V2#1",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Tales of the Zombie",
    "Issue #": 9,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Terratoid Guide",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Fanzine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Terratoid Guide",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "Fanzine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Terror Tales",
    "Issue #": "V1#7",
    "Condition": "VF",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Terror Tales",
    "Issue #": "V1#9",
    "Condition": "VF+",
    "Website Notes": "Bondage Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Terror Tales",
    "Issue #": "V7#3",
    "Condition": "VF/NM",
    "Website Notes": "LSD Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "3-D Batman",
    "Issue #": 1953,
    "Condition": "VG",
    "Website Notes": "No glasses",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 54,
    "": ""
  },
  {
    "Title": "3-D Batman",
    "Issue #": 1966,
    "Condition": "VF",
    "Website Notes": "w/glasses",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 54,
    "": ""
  },
  {
    "Title": "Tiny Tim",
    "Issue #": 1967,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": ""
  },
  {
    "Title": "Tomb of Dracula",
    "Issue #": 5,
    "Condition": "VF/NM",
    "Website Notes": "Lilith",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 17,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 32,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 51,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 69,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 71,
    "Condition": "VG/F",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 71,
    "Condition": "VF/NM",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 73,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 74,
    "Condition": "VF/NM",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Vampirella",
    "Issue #": 113,
    "Condition": "CGC 8.5",
    "Website Notes": "Last Iss",
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 225,
    "": ""
  },
  {
    "Title": "Vampirella Special",
    "Issue #": "NM-",
    "Condition": "",
    "Website Notes": 1977,
    "Personal Notes (Not on website)": "Warren",
    "Cost Basis": 225,
    "": ""
  },
  {
    "Title": "Vampire Tales",
    "Issue #": 5,
    "Condition": "VF",
    "Website Notes": "Origin Morbius",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Warrior",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "Alan Moore",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Warrior",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "Alan Moore",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Warrior",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "Alan Moore",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 20,
    "": ""
  },
  {
    "Title": "Web of Horror",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "1st Published Wrightson C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Weird",
    "Issue #": "V1#10",
    "Condition": "VF",
    "Website Notes": "1st Issue",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird",
    "Issue #": "V5#1",
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Weird",
    "Issue #": "V5#3",
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Weird",
    "Issue #": "V9#2",
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Weird",
    "Issue #": "V11#4",
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": ""
  },
  {
    "Title": "Weird Tales",
    "Issue #": 1974,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 5,
    "": ""
  },
  {
    "Title": "Weird Tales of the Macabre",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "Boris Witch Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Weird Tales of the Macabre",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "Boris Witch Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "World Famous Creatures (1958)",
    "Issue #": 1,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "World Famous Creatures (1958)",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "World Famous Creatures (1958)",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "World Famous Creatures (1958)",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "World Famous Creatures (1958)",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 125,
    "": ""
  },
  {
    "Title": "World Famous Creatures (1958)",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": ""
  }
];
